export default class FilterState {
    constructor(filterform) {
        this.filterForm = filterform;
        this.filterForm.addEventListener('change', this.listenToChanges.bind(this));
        this.inputs = this.filterForm.querySelectorAll('input');

        this.setInitialState();
    }

    setInitialState() {
        const hash = window.location.hash;
        if (hash && hash.length > 1) {
            const filterState = this.parseQueryString(hash.substring(1));
            this.inputs.forEach( (input) => {
                let name = input.getAttribute('name');
                if (name.endsWith('[]')) {
                    name = name.substring(0, name.length - 2);
                }

                let value = filterState[name];
                const values = Array.isArray(value) ? value : [value];
                switch (input.tagName) {
                    case 'SELECT':
                        [...input.querySelectorAll('option')].forEach((option) => {
                            option.selected = values.indexOf(option.value) !== -1;
                        });
                        break;

                    case 'INPUT':
                        switch (input.getAttribute('type')) {
                            case 'radio':
                            case 'checkbox':
                                input.checked = values.indexOf(input.value) !== -1;
                                break;

                            default:
                                if (value === undefined) {
                                    value = '';
                                }
                                input.value = value;
                        }
                        break;
                }
            });
        }
    }

    parseQueryString(queryString) {
        const parts = queryString.split('&');
        const values = {};

        parts.forEach(part => {
            let [name, value] = part.split('=', 2).map(decodeURIComponent);
            let elm = null;
            if (name.endsWith('[]')) {
                elm = document.querySelector(`[name="${name}"][value="${value}"]`);
                name = name.substring(0, name.length - 2);
                if (typeof values[name] == typeof undefined) {
                    values[name] = [];
                }
                values[name].push(value);
            } else {
                elm = document.querySelector(`[name="${name}"]`);
                values[name] = value;
            }
        });

        return values;
    }

    listenToChanges() {
        const filterState = [];
        this.inputs.forEach((input) => {
            const name = input.getAttribute('name');
            let value = false;

            switch (input.tagName) {
                case 'SELECT':
                    value = input.querySelector('option:selected').value;
                    break;

                case 'INPUT':
                    switch (input.getAttribute('type')) {
                        case 'radio':
                        case 'checkbox':
                            if (input.checked) {
                                value = input.value;
                            }
                            break;

                        default:
                            value = input.value;
                    }
                    break;
            }

            if (value) {
                filterState.push(name + '=' + encodeURIComponent(value));
            }
        });

        const hash = filterState.join('&');
        const newLocation =
        location.protocol +
        '//' +
        location.host +
        location.pathname +
        '#' +
        hash;

        if (window.location != newLocation) {
            window.history.pushState({}, '', newLocation);
        }
    }
}